import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=5f32d2ca"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"
import style0 from "./Function.vue?vue&type=style&index=0&id=5f32d2ca&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f32d2ca')) {
      api.createRecord('5f32d2ca', component.options)
    } else {
      api.reload('5f32d2ca', component.options)
    }
    module.hot.accept("./Function.vue?vue&type=template&id=5f32d2ca", function () {
      api.rerender('5f32d2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/Information/components/Function.vue"
export default component.exports